export default "__VITE_ASSET__B12YEdJT__"